import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { AppSessionService } from "@shared/session/app-session.service";
import { RouterModule } from "@angular/router";
import { SupportChatService } from "@app/wapps/system/support/support-chat.service";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatButtonModule } from "@angular/material/button";
import { MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatIconModule } from "@angular/material/icon";
import { Subject, takeUntil } from "rxjs";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { AppAuthService } from "@shared/auth/app-auth.service";
import { FuseSplashScreenService } from "@fuse/services/splash-screen.service";
import { FuseSidebarService } from "@fuse/components/sidebar/sidebar.service";
import { ChangeLeftMenuVisibilityInput, ConfigurationServiceProxy } from "@shared/api/service-proxies";

@Component({
    selector: "v2-toolbar",
    templateUrl: "./v2-toolbar.component.html",
    styleUrls: ["./v2-toolbar.component.scss"],
    standalone: true,
    imports: [MatToolbarModule, MatButtonModule, MatMenuModule, MatTooltipModule, MatIconModule, RouterModule],
})
export class V2ToolbarComponent implements OnInit, OnDestroy {
    private _appSession = inject(AppSessionService);

    private _supportChatService = inject(SupportChatService);

    private _fuseProgressBarService = inject(FuseProgressBarService);

    public fuseSplashService = inject(FuseSplashScreenService);

    private _authService = inject(AppAuthService);

    private _fuseSidebarService = inject(FuseSidebarService);

    private _configurationService = inject(ConfigurationServiceProxy);

    private _domSanitizer = inject(DomSanitizer);

    private _unsubscribeAll = new Subject<void>();

    logoUrl: SafeUrl;

    supportChatEnabled: boolean;

    leftMenuCollapsed: boolean;

    ngOnInit(): void {
        this.supportChatEnabled = this._supportChatService.enabled;

        this._appSession.onTenantInfoChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe((val) => {
            if (this._appSession.tenantInfo && this._appSession.tenantInfo.logoUrl) {
                this.logoUrl = this._domSanitizer.bypassSecurityTrustUrl(this._appSession.tenantInfo.logoUrl);
            } else {
                this.logoUrl = this._domSanitizer.bypassSecurityTrustUrl("assets/images/logos/green.svg");
            }
        });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    openKb() {
        window.open("https://help.vsaude.com.br", "_blank");
    }

    openChat() {
        this._supportChatService.showMessengerPanel();
    }

    logout(): void {
        this._fuseProgressBarService.show();
        this._authService.logout(true);
    }

    toggleSidebarOpened(): void {
        this._fuseSidebarService.getSidebar("main-navbar").toggleOpen();
    }

    toggleSidebarFolded(): void {
        this._fuseSidebarService.getSidebar("main-navbar").toggleFold();
        this.leftMenuCollapsed = !this.leftMenuCollapsed;
        this._configurationService
            .changeLeftMenuVisibility(
                ChangeLeftMenuVisibilityInput.fromJS({
                    collapsed: this._fuseSidebarService.getSidebar("main-navbar").folded,
                })
            )
            .subscribe(() => {});
    }
}
